import { updateLiquidityCashWithOtherBanksPanelSettings } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySettingsMutation } from './use-liquidity-settings-mutation';

export const useUpdateLiquidityCashWithOtherBanksPanelSettings = () =>
    useLiquiditySettingsMutation({
        mutationFn: (payload) => updateLiquidityCashWithOtherBanksPanelSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityCashWithOtherBanksSettings,
        scope: 'panel',
    });
